import React, {Component} from 'react';
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import {REQUEST_FORMS_DATA} from "../actions/formsActions";
import queryString from "query-string";
import {NavLink} from 'react-router-dom';
import {connect} from "react-redux";

const mapStateToProps = state => {
  return {
    formsData: state.formsData
  }
};

const mapDispatchToProps = dispatch => ({
  getFormsData: () => dispatch({type: REQUEST_FORMS_DATA})
});

class Confirmation extends Component {

  componentDidMount() {
    if (!this.props.formsData.forms) {
      this.props.getFormsData();
    }
  }

  render() {

    if (window.top !== window.self) {
      window.top.location = window.self.location;
      return null;
    }

    const querystringParams = queryString.parse(this.props.location.search);
    let form = null;

    if (this.props.formsData.forms) {
      form = this.props.formsData.forms.find((item) => {
        return item.formReferenceName === querystringParams.form;
      });
    }

    return (
      <div className="wrapper">
        {form ?
          <div><Breadcrumbs/>
            <div>
              <h1 className="two-three-rows__title">Thank you</h1>
                {form.title === "Individual Account Application Form"
                        ? <div className="individual-application-confirmation-container">
                            <p className="individual-application-confirmation-step-description">One more step before your application is complete. </p>
                            <p className="two-three-rows__description">We have received your information and will be processing your request. In order to complete your account application, you need to setup a site inspection for your shipping location.</p>
                            <p className="individual-application-confirmation-description">Please contact our <a href="./contact">Cargo Customer Care Center</a> to schedule an appointment</p>
                            </div>

                        : <p className="two-three-rows__description">We have received your information and will be processing your
                    request.
                </p>}

              <div className="iframe-box-wrapper pan">
                <div className="confirmation-container">
                  <div className={form.processingTime || form.emailConfirmation ? "confirmation-column confirmation-column--has-arrow" : "confirmation-column"}>
                    <img className="submitted-image" alt=""
                         src="./assets/application-confirmation/application-submitted.svg"
                    />
                    <p className={form.title === "Individual Account Application Form" ? "individual-account-column__main-text" : "confirmation-column__main-text"}>{form.title} submitted</p>
                  </div>
                    {
                        form.title === "Individual Account Application Form"
                                ? <div className="confirmation-column confirmation-column--has-arrow">
                                <img className="site-inspection-image" alt="site-inspection" src="./assets/application-confirmation/site-inspection-image.png" />
                                <p className="individual-account-column__main-text">Please contact our Cargo Customer Care Center at (800) 533-1222 to set up the site inspection for your shipping location.</p>
                                </div>
                                : null
                    }
                  {form.processingTime ?
                    <div className={form.emailConfirmation ? "confirmation-column confirmation-column--has-arrow" : "confirmation-column"}>
                      <div className="processing">
                        <div className="processing__amount">{form.processingTime.from}</div>
                        <div className="processing__text">to</div>
                        <div className="processing__amount">{form.processingTime.to}</div>
                        <div className="processing__measurement">Business days</div>
                      </div>
                      <p className="confirmation-column__main-text">Processing time</p>
                    </div>
                    : null}
                  {form.emailConfirmation ?
                    <div className="confirmation-column">
                      <img className="confirmation-image" alt=""
                           src="./assets/application-confirmation/email-confirmation.svg"
                      />
                      <p className="confirmation-column__main-text">Email Confirmation</p>
                    </div>
                    : null}
                </div>
              </div>
              <div className="confirmation-footer">
                <div className="confirmation-footer__customer-support">
                <p class="inline-block color-primary-blue text-bold mtm">To make sure you receive emails from Southwest Cargo, check your spam/junk folder and add Southwest Cargo as a trusted contact.</p>
                <p><br></br></p>
                  <p className="mtn">Questions? Call the Cargo Customer Care Center</p>
                  <a href="tel:+18005331222" className="h3 inline-block color-primary-blue text-bold mtm">(800)
                    533-1222</a>
                </div>
                <div>
                  <NavLink to="/" className="cta-button confirmation-footer__back-home">Back to Homepage</NavLink>
                </div>
              </div>
            </div>
          </div>
          : null
        }
      </div>
    )
  }
}

export default (connect(mapStateToProps, mapDispatchToProps)(Confirmation));



// WEBPACK FOOTER //
// ./src/pages/Confirmation.js